import { ChatMessages } from './components/ChatMessages';
import { InputArea } from './components/InputArea';
import { useChat } from './hooks/useChat';
import './styles.css';

export default function Chat() {
  const { messages, input, setInput, handleSubmit } = useChat();

  return (
    <div className="chat-container">
      <ChatMessages messages={messages} />
      <InputArea value={input} onChange={setInput} onSubmit={handleSubmit} />
    </div>
  );
}
